// src/lib/queryClient.ts

import { QueryClient } from '@tanstack/react-query';

// Initialize QueryClient for data fetching with production settings
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: (failureCount, error: any) => {
        // TODO: Backend integration - Implement smart retry logic based on error type
        // Don't retry on 4xx errors except 408 (timeout) and 429 (rate limit)
        if (error?.status >= 400 && error?.status < 500 && error?.status !== 408 && error?.status !== 429) {
          return false;
        }
        return failureCount < 3;
      },
      refetchOnWindowFocus: false,
      // TODO: Backend integration - Add stale time based on data freshness requirements
      staleTime: 1000 * 60 * 5, // 5 minutes
      // TODO: Backend integration - Add cache time configuration
      gcTime: 1000 * 60 * 10, // 10 minutes
    },
  },
});